import * as CatCapabilitiesActions from '../adm-cat-capabilities.actions'
import { IDS } from '../../adm-categorisation-action-id.constants'
/**
 * AdmCatCapabilityDetailsController.
 * @class
 * @memberOf Administration
 */
class AdmCatCapabilityDetailsController {
    constructor($ngRedux, $state, $scope, Notifier, NavigationActions) {
        this.$ngRedux           = $ngRedux;
        this.$state             = $state;
        this.$scope             = $scope;
        this.Notifier           = Notifier;
        this.NavigationActions  = NavigationActions;
    }

    $onInit() {
        this.identifier = IDS.admCatCapabilityDetails;
        this.unsubscribe = this.$ngRedux.connect(
            state => {
                return {
                    formData: state.administration.admCategorisation.admCatCapabilityDetails,
                }
            },
            CatCapabilitiesActions
        )(this);
    }

    onSubmit() {
        this.$scope.$broadcast('show-errors-check-validity', '$ctrl.detailsForm');
        if (this.detailsForm.$valid)
            this.addScheme(this.formData, this.NavigationActions.getConfigs, this.$state);
        else
            this.Notifier.error('COMMON.FIELDS_REQUIRED');
    }

    $onDestroy() {
        this.unsubscribe();
    }
}

AdmCatCapabilityDetailsController.$inject = ['$ngRedux', '$state', '$scope', 'Notifier', 'NavigationActions']

export const admCatCapabilityDetails = {
    controller: AdmCatCapabilityDetailsController,

    template: `
        <tabs-header title="{{'ACCREDITATION.ADD_SCHEME.TITLE' | translate}}"></tabs-header>
        
        <form id="detailsForm" name="$ctrl.detailsForm" noValidate>
            <div layout-gt-xs="row">
                <input-text-area flex class="noMarginBottom"
                    identifier="{{$ctrl.identifier}}"
                    label="Site Capability Name"
                    name="name"
                    state-path="name"
                    required="true"
                    rows="1"
                    max-length="45"></input-text-area>
            </div>
            
            <div layout-xs="column"
                layout-sm="column"
                layout-gt-sm="row"
                flex-gt-md="60"
                layout-align="center center">
                    <div flex hide-xs hide-sm></div>
                    <md-button class="btnColorAccreditations" 
                        name="btnSubmit" 
                        aria-label="Add Scheme" 
                        ng-click="$ctrl.onSubmit()">{{'COMMON.BUTTON.ADD'| translate}}</md-button>
            </div>
        </form>`
}
